import type { Variable } from '@mobileTypes'

/** Maps form variables to option shape { id, name } for Autocomplete / selects. name = internalId for display. */
export function variablesToOptions(
  variables: Variable[]
): Array<{ id: string; name: string }> {
  return variables.map(v => ({ id: v.internalId, name: v.internalId }))
}
